// Import Depndencies
import { isRouteErrorResponse, useRouteError } from "react-router";
import { lazy, useEffect } from "react";

// Local Imports
import { Loadable } from "components/shared/Loadable";
import { useAuthContext } from "app/contexts/auth/context";
import { useAuthModalContext } from "app/contexts/authModal/context";

// ----------------------------------------------------------------------

const app = {
  401: lazy(() => import("./401")),
  404: lazy(() => import("./404")),
  429: lazy(() => import("./429")),
  500: lazy(() => import("./500")),
};

function RootErrorBoundary() {
  const error = useRouteError();
  const { isAuthenticated } = useAuthContext();
  const { openAuthModal } = useAuthModalContext();

  // Not logged in and a route errored out (e.g. a protected fetch failed) →
  // open the SAME global auth modal used everywhere else instead of hard
  // navigating to a separate /login page.
  useEffect(() => {
    if (!isAuthenticated) {
      openAuthModal({ label: "Raajneeti AI" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  if (isAuthenticated) {
    if (isRouteErrorResponse(error)) {
      const Component = Loadable(app[error.status]);
      return <Component />;
    }
  } else {
    // Modal renders itself (mounted globally in AuthModalProvider) — nothing
    // else to show behind it here.
    return null;
  }

  console.error("Unhandled route error:", error);
  return (
    <div className="p-4 font-mono text-red-600">
      <h2 className="text-lg font-bold">Something went wrong</h2>
      <pre className="whitespace-pre-wrap">
        {error?.message || JSON.stringify(error)}
      </pre>
    </div>
  );
}

export default RootErrorBoundary;